export default __webpack_public_path__ + "static/media/testifyNine.9349beb5.png";